import { createFileRoute, redirect } from '@tanstack/react-router';

// `/settings/billing/available-plans` has no page of its own; it redirects to the Journeys plans
// child (`available-plans/journeys`).
export const Route = createFileRoute('/_authenticated/settings/billing/available-plans/')({
  beforeLoad: () => {
    throw redirect({ to: '/settings/billing/available-plans/journeys' });
  },
});
